import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConstant } from '../constants/app-constant';
import { TenantProvider } from '../providers/tenant.provider';
import { RoleService } from '../services/role.service';

@Injectable()
export class NavigationGuard implements CanActivate  {

  constructor(private router: Router, private roleService: RoleService, private tenantProvider: TenantProvider) {
  }
  canActivate() {
    this.roleService.getRole().subscribe(role => {
      let subdomain = this.tenantProvider.getSubdomain();
      let navigationLink = '';

      if (subdomain == AppConstant.AdminTenant) {
        navigationLink = 'pages/tenants';
      }
      else {
        switch (role) {
          case AppConstant.RoleGuest:
            return false;
          case AppConstant.RoleBasic:
            return true;
          default:
            navigationLink = 'pages/customers';
            break;
        }
      }
      this.router.navigateByUrl(navigationLink);
    });

    return true;
  }
}
